import React from 'react';
import PropTypes from 'prop-types';
import Link from 'Components/Link';

import SectionHeader from 'Components/SectionHeader';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from 'Settings/route-strings';

const FreeTrialHeader = ({ source, licenseType }) => {
  let title;
  let descriptionText;
  switch (source) {
    case 'teachervision':
      title = 'Welcome, TeacherVision!';
      descriptionText = (
        <React.Fragment>
          <p>
            Signing up for a trial gives you and your students immediate access
            to Tinybop Schools for 30 days. No credit card required!
          </p>
        </React.Fragment>
      );
      break;
    default:
      title = <ConnectedFormattedMessage id="free_trial_page.title" />;
      descriptionText = (
        <React.Fragment>
          <p>
            <ConnectedFormattedMessage id="free_trial_page.description" />
          </p>
        </React.Fragment>
      );
  }

  const description = (
    <React.Fragment>
      {descriptionText}
      <p>
        <ConnectedFormattedMessage
          id="free_trial_page.selected_plan"
          values={{
            license_name: (
              <strong>
                <ConnectedFormattedMessage
                  id={`pricing_plan.${licenseType}.title`}
                />
              </strong>
            ),
          }}
        />{' '}
        <Link to={ROUTES.PRICING} className="u-text-link">
          <ConnectedFormattedMessage id="free_trial_page.change_plans_link" />
        </Link>
      </p>
    </React.Fragment>
  );

  return <SectionHeader title={title} description={description} />;
};

FreeTrialHeader.propTypes = {
  source: PropTypes.oneOf(['teachervision']),
  licenseType: PropTypes.string,
};

export default FreeTrialHeader;
